import {
  DELETE_ECOMMERCE_PROVIDER,
  INSERT_ECOMMERCE_PROVIDER
} from 'graphql/mutations/integrations';
import * as Yup from 'yup';

const fields = [
  {
    title: 'Alias',
    label: 'Ej. Primera integración',
    keyName: 'alias',
    type: '',
    initialValue: '',
    helperText: 'Introduce un nombre para identificar esta integración',
    validationSchema: Yup.string().required('Ingresa el campo Alias')
  },
  {
    title: 'Dominio',
    label: 'Ej. www.mitienda.com',
    keyName: 'domain',
    type: '',
    initialValue: '',
    helperText: 'Introduce el Dominio',
    validationSchema: Yup.string().required('Ingresa el campo Dominio')
  },
  {
    title: 'WEBHOOK KEY',
    label: 'Ej. webhook_key_example',
    keyName: 'webhookKey',
    type: '',
    initialValue: '',
    helperText: 'Introduce tu SECRET KEY',
    validationSchema: Yup.string().required('Ingresa el campo SECRET KEY')
  },
  {
    title: 'API KEY',
    label: 'Ej. api_key_example',
    keyName: 'apiKey',
    type: '',
    initialValue: '',
    helperText: 'Introduce tu API KEY',
    validationSchema: Yup.string().required('Ingresa el campo API KEY')
  },
  {
    title: 'SECRET KEY',
    label: 'Ej. secret_key_example',
    keyName: 'secretKey',
    type: '',
    initialValue: '',
    helperText: 'Introduce tu API KEY',
    validationSchema: Yup.string().required('Ingresa el campo SECRET KEY')
  }
];

const noDisplayFields = [
  { name: 'clientId', path: 'clientId' },
  { name: 'integratorId', path: 'id' }
];

const ecommerceProviders = ['SHOPIFY', 'ECWID', 'WOOCOMMERCE', 'WIX'].map(
  (item) => ({
    key: item,
    fields,
    noDisplayFields,
    createMutation: INSERT_ECOMMERCE_PROVIDER,
    deleteMutation: DELETE_ECOMMERCE_PROVIDER
  })
);

export default ecommerceProviders;
